import BasicLayout from "../components/BasicLayout";
import {Card, Grid} from "@mui/material";
import MDBox from "../../Components/MDBox";
import {useFormik} from "formik";
import MDTypography from "../../Components/MDTypography";
import MDInput from "../../Components/MDInput";
import MDButton from "../../Components/MDButton";
import {useState} from "react";
import {UserModel} from "../../Api/Model/UserModel";
import * as yup from "yup";
import {toast} from "react-toastify";
import {PromiseToaast} from "../../utils/toast/Toast";
import {useNavigate} from "react-router-dom";
import ULogin from "../../utils/Hooks/ULogin";
import {CurrentUser} from "../../utils/Hooks/currentUser";

const validationSchema = yup.object({
    username: yup
        .string()
        .required("نام کاربری را وارد کنید"),
    password: yup
        .string()
        .required("رمز عبور  را وارد کنید"),
})
export default function LoginPage() {
    const [loading, setLoading] = useState(false);
    var model = new UserModel();
    const navigate = useNavigate();

    const formik = useFormik({
        onSubmit: (r) => {
            setLoading(true)
            PromiseToaast(
                model.Login({
                    grant_type: "password",
                    username: r.username,
                    password: r.password
                }), {
                    success: "با موفقیت وارد شدید",
                    pending: "در حال ورود",
                    error: {
                        render({data}) {

                            if (data) return data.message;
                            return "خطا در ورود";
                        },
                    }
                })
                .then(r => {
                    ULogin(r.data)

                })
                .then(r => {
                    if (CurrentUser().Role === "Admin") {
                        navigate("/users", {replace: true})
                        return;
                    }else if(CurrentUser().Role === "Student"){
                        navigate("/studentlanding", {replace: true})
                        return; 
                    }
                    navigate("/information", {replace: true})
                })
                .catch(c => {
                    setLoading(false)

                })
        },
        initialValues: {
            username: "",
            password: ""
        },
        validationSchema
    });
    return <BasicLayout image={require("../../Asset/images/bgze.png")}>

        <Grid container sx={{height: "100%"}} flexDirection={"row"}>
            <Grid item xs={12} md={4} sm={12} alignSelf={{xs: "center", md: "unset", sm: "center"}}
                  textAlign={"center"}>
                <MDBox sx={{position: "relative"}}>
                    <MDBox pt={4} pb={{xs: 0, md: 3, sm: 3}} component="form" role="form"
                           onSubmit={formik.handleSubmit}>
                        <Grid container direction={"column"} alignItems={"center"}>
                            <Grid item>
                                <MDBox px={10} bgColor={"rgba(255,255,255,0.02)"}>
                                    <MDTypography color={"inherit"} fontWeight={"bold"}
                                                  sx={{
                                                      color: "rgb(52,39,9)", textShadow: "1px 0px 15px #fff",
                                                      fontSize: {xs: 30, md: 40, sm: 30}
                                                  }}>سامانه قهرمان سلامت</MDTypography>
                                </MDBox>
                            </Grid>
                        </Grid>
                    </MDBox>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={8} sm={12}>
                <MDBox sx={{position: "relative"}}>
                    <MDBox pt={{xs: 0, md: 4, sm: 4}} pb={3} component="form" role="form"
                           onSubmit={formik.handleSubmit}>
                        <Grid container direction={"column"} alignItems={"center"}>
                            <Grid item>
                                <MDBox py={{xs: 0, md: 10, sm: 10}}>
                                    <MDTypography fontSize={30} color={"dark"} fontWeight={"bold"}>
                                        صفحه ورود
                                    </MDTypography>
                                </MDBox>
                            </Grid>
                            <Grid container item direction={"column"} rowSpacing={"2rem"} textAlign={"center"}>
                                <Grid item>
                                    <MDInput
                                        login={true}
                                        id="username"
                                        name="username"
                                        value={formik.values.username}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.username && Boolean(formik.errors.username)
                                        }
                                        helperText={formik.touched.username && formik.errors.username}
                                        autoComplete={"username"}
                                        disabled={loading}
                                        fullWidth
                                        sx={{width: {xs: "90%", md: "50%", sm: "50%",}}}
                                        label={"نام کاربری"}/>
                                </Grid>
                                <Grid item>
                                    <MDInput
                                        login={true}
                                        id="password"
                                        name="password"
                                        type={"password"}
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.password && Boolean(formik.errors.password)
                                        }
                                        helperText={formik.touched.password && formik.errors.password}
                                        autoComplete={"password"}
                                        disabled={loading}
                                        sx={{width: {xs: "90%", md: "50%", sm: "50%",}}}

                                        label={"رمز عبور"}/>
                                </Grid>
                                <Grid container item justifyContent={"center"}>
                                    <MDBox sx={{background: "#ffffffa6", cursor: "pointer"}}
                                           onClick={() => navigate("/register")} px={2} py={1} borderRadius={"10px"}>
                                        <MDTypography fontWeight={"bold"}>حساب کاربری ندارید؟ ثبت نام
                                            کنید</MDTypography>
                                    </MDBox>
                                </Grid>
                            </Grid>
                        </Grid>
                        <MDBox mt={12} mb={1} textAlign={"center"}>
                            <MDButton variant="gradient"
                                      sx={{
                                          background: "#01458D",
                                          width: {xs: "90%", md: "50%", sm: "50%"},
                                          fontSize: "1.2rem",
                                          height: "60px"
                                      }}

                                      type="submit"
                                      disabled={loading}
                                      fullWidth>
                                ورود
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Grid>

        </Grid>

    </BasicLayout>
}